import React from "react";

import FormFactory from "../../../../components/form/form-factory";

import * as S from "./styles";

import IProps from "./props";

const Login: React.FC<IProps> = ({ onSubmit, dataForm, errorMessage }) => (
  <S.Container>
    <S.SubTitle>Seja bem vindo!</S.SubTitle>
    <S.Title>Realize seu Login</S.Title>
    <FormFactory
      data={dataForm}
      onSubmit={onSubmit}
      submitErrorMessage={errorMessage}
    />
    <S.RegisterLink to="/registrar">
      Não possui conta? <span>Cadastre-se com e-mail</span>
    </S.RegisterLink>
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);
export default Login;
